<template>
<article class="info-section elr-container-full" v-if="item">
  <div class="elr-row">
    <div class="elr-col-full">
      <div class="info-section-header">
        <InfoSectionHeading>Edit {{capitalized}}</InfoSectionHeading>
      </div>
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-half">
      <div v-if="isEditor">
        <transition mode="out-in" name="fade">
          <Spinner v-if="status === 'updating'" key="spinner" />
          <slot v-else />
        </transition>
      </div>
      <div v-else>
        <h2 class="info-section-subheading">You are not authorized to edit</h2>
        <div class="button-holder">
          <div class="elr-text-left">
            <router-link :to="`/${model}`" class="elr-button elr-button-primary">See All {{pluralName}}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="elr-col-half item-data">
      <!-- <Spinner v-if="status === 'loading'" key="spinner" /> -->
      <DataList :fields="fields" :item="item" />
      <figure v-if="item.image" class="item-image">
        <img :src="`/pony-images/${item.image.image_path}`" alt="">
      </figure>
      <router-link :to="`/${model}/${item.id}`" class="elr-button elr-button-primary">View {{modelName}}</router-link>
    </div>
  </div>
</article>
</template>

<script>
import { capitalize, deslugify, plural, } from '../../utils/helpers';
import { mapGetters } from 'vuex';
import Spinner from '../../components/Spinner/Spinner';
import DataList from '../../components/DataList/DataList';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'EditItem',
  props: {
    model: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: () => ([]),
    }
  },
  components: {
    DataList,
    Spinner,
    InfoSectionHeading,
  },
  computed: {
    ...mapGetters('currentUser', ['isEditor']),
    pluralName() {
      return capitalize(plural(this.model));
    },
    capitalized() {
      return capitalize(this.item.name);
    },
    modelName() {
      return capitalize(deslugify(this.model));
    },
  },
};
</script>

<style lang="scss" scoped>
.item-data {
  padding: 20px 20px 20px 60px;
}

.item-image {
  margin-bottom: 40px;
}

.item-image img {
  max-width: 400px;
  max-height: 300px;
  height: auto;
}
</style>

